export default class Payment {
  setPaymentNumber(value) {
    this.paymentNumber = value;
    return this;
  }

  setAmortization(value) {
    this.amortization = value;
    return this;
  }

  setInterest(value) {
    this.interest = value;
    return this;
  }

  setMonthlyPayment(value) {
    this.monthlyPayment = value;
    return this;
  }

  setBalance(value) {
    this.balance = value;
    return this;
  }

  setIsPaid(value) {
    this.isPaid = value;
    return this;
  }
}
